import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import SpotifyRadio from './components/SpotifyRadio';
import MoonParties from './components/MoonParties';
import Podcasts from './components/Podcasts';
import RecordLabel from './components/RecordLabel';
import SocialMedia from './components/SocialMedia';
import Contact from './components/Contact';
import LanguageSwitcher from './components/LanguageSwitcher';

function App() {
  useEffect(() => {
    const trackVisit = async () => {
      try {
        const response = await fetch('/api/tracking/request-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_url: window.location.href
          })
        });
        const data = await response.json();
        if (data.success) {
          localStorage.setItem('tracking_token', data.token);
        }
      } catch (error) {
        console.error('Tracking failed:', error);
      }
    };
    trackVisit();
  }, []);

  return (
    <div className="App">
      <div className="background-overlay"></div>

      {/* Visual Elements - Scattered throughout the page */}
      <div className="surfboard-element visual-element"></div>
      <div className="palm-tree-element visual-element"></div>
      <div className="incense-smoke visual-element"></div>

      {/* Additional decorative elements */}
      <div className="floating-elements">
        <div className="floating-note">♪</div>
        <div className="floating-note">♫</div>
        <div className="floating-note">♬</div>
      </div>

      <LanguageSwitcher />
      <Header />
      <main>
        <SpotifyRadio />
        <MoonParties />
        <Podcasts />
        <RecordLabel />
        <SocialMedia />
        <Contact />
      </main>
    </div>
  );
}

export default App;